// removed by extract-text-webpack-plugin
module.exports = {"pure-text-container":"pure-text-container_adGod","pureTextContainer":"pure-text-container_adGod","title-box":"title-box_adGod","titleBox":"title-box_adGod","title":"title_adGod","display-gods":"display-gods_adGod","displayGods":"display-gods_adGod","gods-group":"gods-group_adGod","godsGroup":"gods-group_adGod","god-text":"god-text_adGod","godText":"god-text_adGod","slider-container":"slider-container_adGod","sliderContainer":"slider-container_adGod"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdGod/adGod.scss
// module id = 119
// module chunks = 0